<template>
    <div class="pageRegisterLink">
        <div class="page-head">
            <div class="jobMain">
                <div class="jobContent" :class="{ 'jobContent--supplement': isSupplementPage }">
                    <div class="jobStep">
                        <div class="jobStep-bar"></div>
                        <div class="jobStep-list">
                            <el-row>
                                <el-col :span="8">
                                    <div class="jobStep-li">
                                        <div class="jobStep-icon-success"><i class="el-icon-success"></i></div>
                                        <div class="jobStep-text-success">提交报名</div>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="jobStep-li" v-if="myJobData.approval_status===0">
                                        <div class="jobStep-icon-check"><i class="el-icon-edit"></i></div>
                                        <div class="jobStep-text-check print-time">待签名</div>
                                    </div>
                                    <div class="jobStep-li" v-else-if="myJobData.approval_status===2">
                                        <div class="jobStep-icon-check"><i class="el-icon-refresh-right"></i></div>
                                        <div class="jobStep-text-check print-time">资格审查</div>
                                    </div>
                                    <div class="jobStep-li" v-else-if="myJobData.approval_status===3">
                                        <div class="jobStep-icon-success"><i class="el-icon-success"></i></div>
                                        <div class="jobStep-text-success print-time">资格审查</div>
                                    </div>
                                    <div class="jobStep-li" v-else-if="myJobData.approval_status===4">
                                        <div class="jobStep-icon-error"><i class="el-icon-error"></i></div>
                                        <div class="jobStep-text-error print-time">审核不通过</div>
                                    </div>
                                    <div class="jobStep-li" v-else-if="myJobData.approval_status===1">
                                        <div class="jobStep-icon-check"><i class="el-icon-warning-outline"></i></div>
                                        <div class="jobStep-text-check print-time">需补充资料</div>
                                    </div>
                                    <div class="jobStep-li" v-else>
                                        <div class="jobStep-icon-default"><i class="icon-number">2</i></div>
                                        <div class="jobStep-text-default print-time">资格审查</div>
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="jobStep-li" v-if="myJobData.approval_status===3">
                                        <div class="jobStep-icon-check"><i class="icon-number">3</i></div>
                                        <div class="jobStep-text-check print-time">准考证打印</div>
                                        <div class="jobStep-print-time" v-if="myJobData.approval_status===3">{{ ticketPrintStepText }}</div>
                                    </div>
                                    <div class="jobStep-li" v-else>
                                        <div class="jobStep-icon-default"><i class="icon-number">3</i></div>
                                        <div class="jobStep-text-default print-time">准考证打印</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-main">
            <div class="jobContent" :class="{ 'jobContent--supplement': isSupplementPage }">
                <div class="jobContent-t clearfix">
                    <div class="jobContent-tle">{{ pageContentTitle }}</div>
                    <div class="jobContent-tr">
                        <div class="jobContent-tr-btn">
                            <el-button
                                v-if="showSupplementMaterialButton"
                                plain
                                @click="onSupplementMaterialButtonClick"
                            ><i class="el-icon-folder-add"></i> {{ supplementMaterialButtonText }}</el-button>
                        </div>
                        <div class="jobContent-tr-btn">
                            <el-button
                                plain
                                v-if="myJobData.approval_status===3"
                                :loading="downloadingApplicationForm"
                                :disabled="downloadingApplicationForm"
                                @click="downloadApplicationFormPdf"
                            ><i class="el-icon-download"></i> 下载报名表</el-button>
                        </div>
                        <div class="jobContent-tr-btn">
                            <el-button
                                v-if="myJobData.approval_status===3"
                                type="danger"
                                :loading="navigatingToPrint"
                                :disabled="navigatingToPrint"
                                @click="goToPrintTicketPage"
                            ><i class="el-icon-document-checked"></i> 前往打印准考证</el-button>
<!--                            <el-button plain disabled v-else><i class="el-icon-printer"></i> 审核通过后开放打印</el-button>-->
                        </div>
                    </div>
                </div>
                <div class="jobAddInformation" v-if="myJobData.approval_status===1">
                    <div class="jobAddInformation-top clearfix">
                        <div class="jAI-tlef">
                            <div class="jAI-tlef-icon"><i class="el-icon-circle-close"></i></div>
                        </div>
                        <div class="jAI-trig">
                            <div class="jAI-trig-t">
                                <div class="jAI-trig-tle">需补充资料</div>
                            </div>
                            <div class="jAI-trig-intro">您的报名材料已收到，经初步审核，资料暂不符合要求。请根据以下意见修改报名表与附件，完成后统一提交，无需再次签名。</div>
                            <div class="jAI-trig-tips">
                                <div class="jAI-trig-tip1"><i class="el-icon-document"></i> 审核员反馈意见：</div>
                                <template v-if="approvalFeedbackLines.length">
                                    <div class="jAI-trig-tip2" v-for="(line, index) in approvalFeedbackLines" :key="'fb-' + index">{{ line }}</div>
                                </template>
                                <div class="jAI-trig-tip2" v-else>{{ approvalFeedbackText }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <application-supplement-form
                    v-if="myJobData.approval_status===1"
                    :application-data="myJobData"
                    @submitted="onSupplementSubmitted"
                />
                <div ref="toPdf" id="printDom" v-if="myJobData.approval_status!==1">
                    <div ref="applicationFormMain" class="print-main">
                        <div class="print-mt">
                            <table class="job-t-table">
                                <tr>
                                    <td width="10%">
                                        <div class="print-mt-logo"><img src="../assets/logo.png" /></div>
                                    </td>
                                    <td width="90%" class="print-mt-mid-cell">
                                        <div class="print-mt-mid-t">
                                            <div class="print-mt-mid-title">报名表</div>
                                            <div class="print-mt-mid-major" :class="printPositionNameSizeClass">{{ displayPositionsName }}</div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="print-msubt clearfix">
                            <div class="print-msubt-l">
                                <div class="print-msubt-lw"><B>填报时间：</B>{{ myJobData.created_at }}</div>
                            </div>
                            <div class="print-msubt-r">
                                <div class="print-msubt-lw"><B>填写方式：</B>{{ fileMethod[myJobData.fill_method] }}</div>
                            </div>
                        </div>
                        <div class="print-mm">
                            <table class="print-mtable">
                                <tr>
                                    <td class="t1" colspan="9"><i class="el-icon-document tdIcon"></i> 填写内容 (基本资料)</td>
                                </tr>
                                <tr>
                                    <td width="20%" class="t2">姓&emsp;&emsp;名</td>
                                    <td width="20%" colspan="2" class="lw">{{ myJobData.name }}</td>
                                    <td width="20%" colspan="3" class="t2">性&emsp;&emsp;别</td>
                                    <td width="20%" colspan="2" class="lw">{{ {0:'女',1:'男',2:'其他'}[myJobData.gender] }}</td>
                                    <td width="20%" rowspan="5">
                                        <img class="print-avatar" v-if="myJobData.photo_url" :src="myJobData.photo_url" />
                                        <img class="print-avatar" v-else src="../assets/images/defaultPhoto.jpeg" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="t2">手  机  号</td>
                                    <td colspan="2" class="lw">{{ myJobData.phone }}</td>
                                    <td colspan="3" class="t2">政治面貌</td>
                                    <td colspan="2" class="lw">{{ zzmm[myJobData.political_status] }}</td>
                                </tr>
                                <tr>
                                    <td class="t2">身份证号</td>
                                    <td colspan="7" class="lw">{{ myJobData.id_card_number }}</td>
                                </tr>
                                <tr>
                                    <td class="t2">常住地址</td>
                                    <td colspan="7" class="lw">{{ displayResidentAddress }}</td>
                                </tr>
                                <tr>
                                    <td class="t2">籍&emsp;&emsp;贯</td>
                                    <td colspan="7" class="lw">{{ displayNativePlace }}</td>
                                </tr>
                                <tr>
                                    <td class="t2">应聘专业</td>
                                    <td colspan="8" class="lw">{{ displayPositionsName }}</td>
                                </tr>
                                <tr>
                                    <td class="t2">最高学历</td>
                                    <td colspan="8" class="lw">{{ displayHighestEducation }}</td>
                                </tr>
                                <tr>
                                    <td class="t2">邮&emsp;&emsp;箱</td>
                                    <td colspan="8" class="lw">{{ myJobData.email }}</td>
                                </tr>
                                <tr>
                                    <td width="28%" colspan="2" :rowspan="myJobData.familyNum" class="t2">家庭成员</td>
                                    <td width="18%" colspan="2" class="t2">成员关系</td>
                                    <td width="18%" colspan="2" class="t2">姓名</td>
                                    <td width="18%" colspan="2" class="t2">手机号</td>
                                    <td width="18%" class="t2">工作单位</td>
                                </tr>
                                <tr v-for="(item,index) in myJobData.family" :key="index">
                                    <td colspan="2">{{ relationType[item.relationType] }}</td>
                                    <td colspan="2">{{ item.name }}</td>
                                    <td colspan="2">{{ item.mobile }}</td>
                                    <td>{{ item.workUnit || item.work_unit || '—' }}</td>
                                </tr>
                                <tr>
                                    <td class="t1" colspan="9"><i class="el-icon-medal tdIcon"></i> 学历信息 & 附件</td>
                                </tr>
                                <template v-for="(edu, eduIdx) in printEducationSegments">
                                    <tr :key="'edu-h-' + eduIdx">
                                        <td class="t1 print-edu-seg-title" colspan="9">{{ edu.segmentTitle }}</td>
                                    </tr>
                                    <tr :key="'edu-1-' + eduIdx">
                                        <td colspan="2" class="t2">学&emsp;&emsp;校</td>
                                        <td colspan="3" class="lw">{{ edu.graduatedInstitution || '—' }}</td>
                                        <td colspan="2" class="t2">学科/专业</td>
                                        <td colspan="2" class="lw">{{ edu.major || '—' }}</td>
                                    </tr>
                                    <tr v-if="edu.majorCode" :key="'edu-code-' + eduIdx">
                                        <td colspan="2" class="t2">专业代码</td>
                                        <td colspan="7" class="lw">{{ edu.majorCode }}</td>
                                    </tr>
                                    <tr :key="'edu-2-' + eduIdx">
                                        <td colspan="2" class="t2">学&emsp;&emsp;历</td>
                                        <td colspan="3" class="lw">{{ edu.educationLevel || '—' }}</td>
                                        <td colspan="2" class="t2">毕业日期</td>
                                        <td colspan="2" class="lw">{{ edu.departureDate || '—' }}</td>
                                    </tr>
                                    <tr :key="'edu-3-' + eduIdx">
                                        <td colspan="2" class="t2">国内院校</td>
                                        <td colspan="3" class="lw">{{ edu.isDomesticText || '—' }}</td>
                                        <td v-if="edu.isDomesticYes" colspan="2" class="t2">{{ edu.institutionLabel }}</td>
                                        <td v-if="edu.isDomesticYes" colspan="2" class="lw">{{ edu.institutionValue || '—' }}</td>
                                        <td v-if="edu.isDomesticNo" colspan="2" class="t2">{{ edu.institutionLabel }}</td>
                                        <td v-if="edu.isDomesticNo" colspan="2" class="lw">{{ edu.institutionValue || '—' }}</td>
                                        <td v-if="!edu.isDomesticYes && !edu.isDomesticNo" colspan="4" class="lw">—</td>
                                    </tr>
                                    <tr :key="'edu-4-' + eduIdx">
                                        <td colspan="2" class="t2">学信网学籍</td>
                                        <td colspan="3" class="lw">{{ edu.attachXuexin }}</td>
                                        <td colspan="2" class="t2">毕业证</td>
                                        <td colspan="2" class="lw">{{ edu.attachGrad }}</td>
                                    </tr>
                                    <tr :key="'edu-5-' + eduIdx">
                                        <td colspan="2" class="t2">学位证</td>
                                        <td colspan="3" class="lw">{{ edu.attachDegree }}</td>
                                        <template v-if="edu.isDomesticNo">
                                            <td colspan="2" class="t2">教育部留学服务中心认证</td>
                                            <td colspan="2" class="lw">{{ edu.attachStudyAbroad }}</td>
                                        </template>
                                        <template v-else>
                                            <td colspan="2" class="t2"></td>
                                            <td colspan="2" class="lw"></td>
                                        </template>
                                    </tr>
                                </template>
                                <tr>
                                    <td colspan="9" class="t2">附件资料清单 (共 {{ personalAttachmentCount }} 项)</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="t2">身份证正面</td>
                                    <td colspan="3" class="lw">{{ upStatus.idFront }}</td>
                                    <td colspan="2" class="t2">身份证反面</td>
                                    <td colspan="2" class="lw">{{ upStatus.idBack }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="t2">免冠照</td>
                                    <td colspan="3" class="lw">{{ upStatus.photo }}</td>
                                    <td colspan="2" class="t2">无犯罪记录证明</td>
                                    <td colspan="2" class="lw">{{ upStatus.criminalRecord }}</td>
                                </tr>
                                <tr>
                                    <td colspan="9" class="lw">
                                        <div class="print-commitment">
                                            <div class="print-commitment-t"><i class="el-icon-success"></i> 承诺声明</div>
                                            <div class="print-commitment-b">本人承诺所填报的全部内容真实有效，按要求仅报考一个单位。若刻意隐瞒或遗漏任何影响公司作出正确判断的重大事项，本人愿承担全部责任。</div>
                                        </div>
                                        <div class="print-commitment-signb clearfix">
                                            <span class="print-commitment-signline"><img v-if="signImgSrc" :src="signImgSrc" /></span>
                                            <span class="print-commitment-signbtip">本人签字：</span>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="print-mb">System Ref: 9482-ADFA-2291-L3796 | Page 1 of 1</div>
                    </div>
                    <div style="page-break-after: always;"></div>
                    <div class="print-main">
                        <div class="bm-file-tle">
                            <el-divider><span style="font-size: 24px;">附件详情</span></el-divider>
                        </div>
                        <div v-for="item in allAttachmentPreviewList" :key="item.key">
                            <div class="bm-file-p">
                                <attachment-preview-item :url="item.url" />
                            </div>
                            <div class="bm-file-name">{{ item.label }}</div>
                        </div>
                    </div>
                </div>
                <el-alert
                    v-if="applicationFormLocked"
                    title="报名表已保存并提交，报名信息已锁定不可修改"
                    type="success"
                    :closable="false"
                    show-icon
                    style="margin-bottom: 16px;"
                />
                <div class="regJob-dom" v-if="showSignSaveSection" v-loading="savingApplicationForm" element-loading-text="正在提交，请稍候...">
                    <div class="regJob-tle">电子签名</div>
                    <div class="regJob-sign-tip">请核对报名表与附件信息，签名并保存后进入资格审查环节。</div>
                    <div>
                        <div class="sign-area" :class="{'sign-area--locked': signLocked}">
                            <vue-esign ref="esign" :lineWidth="6" lineColor="#000000" class="dragDom"/>
                        </div>
                        <el-button size="small" :disabled="signLocked || savingApplicationForm" @click="signReset">清空签名</el-button>
                        <el-button type="primary" size="small" :disabled="signLocked || savingApplicationForm" @click="signGenerate">确认签名</el-button>
                    </div>
                    <div style="text-align: center; padding-top: 12px;">
                        <el-button type="primary" :loading="savingApplicationForm" :disabled="savingApplicationForm" @click="gotoSign">签名确认并提交</el-button>
                    </div>
                </div>
                <div class="checkRecords clearfix">
                    <div class="bstatus-lef">
                        <div class="bstatus-tle">审核状态</div>
                        <div :class="approvalStatusMeta.class">
                            <i :class="approvalStatusMeta.icon"></i> {{ approvalStatusMeta.label }}
                        </div>
                        <div v-if="displayApprovalComment" class="bstatus-comment">
                            <span class="bstatus-comment-label">审批意见：</span>{{ displayApprovalComment }}
                        </div>
                    </div>
                    <div class="bstatus-rig">
                        <div class="bstatus-tle">操作记录</div>
                        <div class="bstatus-tle">
                            <span v-if="latestApprovalRecord">
                                {{ latestApprovalRecord.approvalByName || latestApprovalRecord.approval_by_name || '—' }}
                                [{{ formatApprovalTime(latestApprovalRecord.approvalTime || latestApprovalRecord.approval_time) }}]
                            </span>
                            <span v-else>无</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <el-dialog title="确认签名并提交" :visible.sync="confirmDialogVisible" width="30%">
                <span>确认签名并提交信息吗？</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="confirmDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmQm">确 定</el-button>
                </span>
        </el-dialog>-->
        <el-dialog
            title="补充资料"
            :visible.sync="supplementUploadDialogVisible"
            width="620px"
            top="8vh"
            @closed="onSupplementUploadDialogClosed">
            <div class="supplement-material-tip">
                请上传技能证书、荣誉证明、论文等材料，只允许上传一次。
            </div>
            <div class="supplement-material-tip supplement-material-tip-sub">
                支持图片或 PDF，可上传多个文件，单个文件不超过 5M。
            </div>
            <div class="supplement-upload-toolbar">
                <input
                    ref="supplementFileInput"
                    type="file"
                    multiple
                    accept=".pdf,image/*"
                    class="supplement-file-input"
                    @change="onSupplementFilesSelected"
                />
                <el-button type="primary" plain @click="triggerSupplementFileSelect"><i class="el-icon-upload2"></i> 选择文件</el-button>
            </div>
            <ul v-if="supplementPendingFiles.length" class="supplement-pending-list">
                <li v-for="(item, index) in supplementPendingFiles" :key="'sup-pending-' + index">
                    <span class="supplement-pending-name">{{ item.name }}</span>
                    <span class="supplement-pending-size">{{ formatFileSize(item.size) }}</span>
                    <el-button type="text" class="supplement-pending-del" @click="removeSupplementPendingFile(index)">移除</el-button>
                </li>
            </ul>
            <div v-else class="supplement-pending-empty">暂未选择文件</div>
            <span slot="footer">
                <el-button @click="supplementUploadDialogVisible = false">取消</el-button>
                <el-button
                    type="danger"
                    :loading="supplementUploadSubmitting"
                    :disabled="!supplementPendingFiles.length"
                    @click="submitSupplementMaterials"
                >确认上传</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="查看补充附件资料"
            :visible.sync="supplementViewDialogVisible"
            width="560px"
            top="10vh">
            <div v-if="!supplementMaterialFiles.length" class="supplement-pending-empty">暂无补充资料</div>
            <ul v-else class="supplement-view-list">
                <li v-for="(item, index) in supplementMaterialFiles" :key="'sup-view-' + (item.id || index)">
                    <a :href="item.fileUrl || item.file_url" target="_blank" rel="noopener noreferrer">
                        {{ item.fileName || item.file_name || ('附件' + (index + 1)) }}
                    </a>
                </li>
            </ul>
            <span slot="footer">
                <el-button @click="supplementViewDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import moment from "moment";
import md5 from "js-md5";
import school from "../assets/school";
import { formatGraduationYear } from '../utils/graduationDate';
import vueEsign from 'vue-esign'
import AttachmentPreviewItem from './AttachmentPreviewItem.vue'
import ApplicationSupplementForm from './ApplicationSupplementForm.vue'
import { validatePrintTicketAccess } from '../utils/printTicketAccess'
import { exportDomToPdf } from '../utils/exportDomToPdf'

export default {
    name: 'PageMyjob',
    data() {
        return {
            myJobData: {},
            fileMethod: {0:"网页端",1:"煤婆新消息",2:"微信小程序",3:"其他"},
            spzt: {1:"待提交",2:"审批中",3:"已通过",4:"审核不通过"},
            zzmm: {1:"中共党员",2:"中共预备党员",3:"共青团员",4:"民革成员",5:"民盟成员",6:"民建成员",7:"民进成员",8:"农工党成员",9:"致公党成员",10:"九三学社社员",11:"台盟成员",12:"无党派人士",13:"群众"},
            relationType: {0:"父亲",1:"母亲",2:"配偶",3:"子女",4:"兄弟",5:"姐妹",6:"其他"},
            fileType: {1:"身份证人像面",2:"身份证国徽面",3:"免冠照",4:"个人简历",5:"毕业证",6:"学位证",7:"学信网学籍"},
            fileTypes: [
                {label:"身份证人像面", value: 1},
                {label:"身份证国徽面", value: 2},
                {label:"免冠照", value: 3},
                // {label:"个人简历", value: 4},
                {label:"毕业证", value: 5},
                {label:"学位证", value: 6},
                {label:"学信网学籍", value: 7}],
            upStatus: {
                idFront: '未上传',
                idBack: '未上传',
                photo: '未上传',
                criminalRecord: '未上传',
            },
            personalAttachmentCount: 0,
            familyNum: 2,
            fileNum: 0,
            fType: 1,
            files: {f1: null, f2: null, f3: null, f4: null, f5: null, f6: null, f7: null},
            bmFile: {bf1: null, bf2: null, bf3: null, bf4: null, bf5: null, bf6: null, bf7: null},
            confirmDialogVisible: false,
            signImgSrc: "",
            signLocked: false,
            applicationFormLocked: false,
            savingApplicationForm: false,
            segmentAttachMap: {},
            printEducationSegments: [],
            allAttachmentPreviewList: [],
            ticketPrintStepText: '下载准考证时间另行通知',
            ticketPrintEffective: null,
            navigatingToPrint: false,
            downloadingApplicationForm: false,
            supplementMaterialFiles: [],
            supplementMaterialUploaded: false,
            supplementUploadDialogVisible: false,
            supplementViewDialogVisible: false,
            supplementPendingFiles: [],
            supplementUploadSubmitting: false,
        }
    },
    components: {
        vueEsign,
        AttachmentPreviewItem,
        ApplicationSupplementForm,
    },
    computed: {
        displayHighestEducation() {
            const d = this.myJobData || {};
            return d.highest_education || d.highestEducation || d.education || '—';
        },
        displayResidentAddress() {
            const d = this.myJobData || {};
            const address = (d.address || '').trim();
            if (address) {
                return address;
            }
            const native = (d.native_place || d.nativePlace || '').trim();
            const hasRegion = (d.resident_province_city || d.residentProvinceCity || d.resident_city || d.residentCity);
            if (native && !hasRegion) {
                return native;
            }
            return '—';
        },
        displayNativePlace() {
            const d = this.myJobData || {};
            const parts = [
                d.resident_province_city || d.residentProvinceCity,
                d.resident_city || d.residentCity,
            ].filter((v) => v != null && String(v).trim() !== '');
            if (parts.length) {
                return parts.join(' ');
            }
            return (d.native_place || d.nativePlace || '').trim() || '—';
        },
        displayPositionsName() {
            const d = this.myJobData || {};
            const entrance = d.entrance_type != null ? d.entrance_type : d.entranceType;
            if (Number(entrance) === 2) {
                return this.formatOperationPositionName(d);
            }
            return (d.positionsName || d.positions_name || '').trim() || '—';
        },
        printPositionNameSizeClass() {
            const name = (this.displayPositionsName || '').trim();
            const len = name.length;
            if (len > 16) {
                return ['print-mt-mid-major--xs', 'print-mt-mid-major--wrap'];
            }
            if (len > 12) {
                return 'print-mt-mid-major--sm';
            }
            if (len > 9) {
                return 'print-mt-mid-major--md';
            }
            return '';
        },
        showSignSaveSection() {
            const status = Number(this.myJobData.approval_status);
            return !this.applicationFormLocked && status === 0;
        },
        pageContentTitle() {
            return Number(this.myJobData.approval_status) === 1 ? '补充报名资料' : '应聘档案预览';
        },
        isSupplementPage() {
            return Number(this.myJobData.approval_status) === 1;
        },
        currentApprovalStatus() {
            const d = this.myJobData || {};
            const raw = d.approval_status != null ? d.approval_status : d.approvalStatus;
            if (raw === '' || raw === null || raw === undefined) {
                return null;
            }
            return Number(raw);
        },
        showSupplementMaterialButton() {
            return this.currentApprovalStatus === 3;
        },
        supplementMaterialButtonText() {
            return this.supplementMaterialUploaded ? '查看补充附件资料' : '补充资料';
        },
        approvalStatusMeta() {
            const map = {
                0: { label: '待签名', class: 'bstatus-lb-pending', icon: 'el-icon-edit' },
                1: { label: '需补充资料', class: 'bstatus-lb-pending', icon: 'el-icon-warning-outline' },
                2: { label: '资格审查中', class: 'bstatus-lb-ing', icon: 'el-icon-refresh-right' },
                3: { label: '资格审查通过', class: 'bstatus-lb', icon: 'el-icon-success' },
                4: { label: '审核不通过', class: 'bstatus-lb-no', icon: 'el-icon-warning' },
            };
            const status = this.currentApprovalStatus;
            return map[status] || { label: '未知状态', class: 'bstatus-lb-pending', icon: 'el-icon-question' };
        },
        latestApprovalRecord() {
            const logs = (this.myJobData && (this.myJobData.approvalLogs || this.myJobData.approval_logs)) || [];
            if (!Array.isArray(logs) || !logs.length) {
                return null;
            }
            const status = this.currentApprovalStatus;
            const matched = logs.find((log) => {
                const s = log.approval_status != null ? log.approval_status : log.approvalStatus;
                return Number(s) === status;
            });
            return matched || logs[0];
        },
        displayApprovalComment() {
            const d = this.myJobData || {};
            let comment = String(d.approval_comment || d.approvalComment || '').trim();
            const record = this.latestApprovalRecord;
            if (record) {
                const logComment = String(record.approval_comment || record.approvalComment || '').trim();
                if (logComment) {
                    comment = logComment;
                }
            }
            return comment;
        },
        approvalFeedbackText() {
            const d = this.myJobData || {};
            let comment = String(d.approval_comment || d.approvalComment || '').trim();
            if (!comment) {
                const logs = d.approvalLogs || d.approval_logs || [];
                if (Array.isArray(logs) && logs.length) {
                    const needSupplementLog = logs.find((log) => {
                        const s = log.approval_status != null ? log.approval_status : log.approvalStatus;
                        return Number(s) === 1;
                    });
                    const target = needSupplementLog || logs[0];
                    comment = String(target.approval_comment || target.approvalComment || '').trim();
                }
            }
            return comment || '暂无审核反馈意见';
        },
        approvalFeedbackLines() {
            const text = this.approvalFeedbackText;
            if (!text || text === '暂无审核反馈意见') {
                return [];
            }
            return text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
        },
    },
    mounted() {
        document.title = '潞安招聘-我的应聘';
        this.getJobInfo();
    },
    methods: {
        onSupplementSubmitted() {
            this.$alert('补充资料已提交，已进入资格审查环节', '提示', {
                confirmButtonText: '确定',
                type: 'success',
            });
            this.getJobInfo();
        },
        formatApprovalTime(time) {
            if (!time) {
                return '—';
            }
            return String(time).replace('T', ' ').substring(0, 19);
        },
        formatOperationPositionName(d) {
            if (!d) {
                return '—';
            }
            const majorCategory = String(d.major_category || d.majorCategory || '').trim();
            const majorName = String(d.major_name || d.majorName || '').trim();
            const positionsName = (d.positionsName || d.positions_name || '').trim();
            if (majorCategory) {
                return majorCategory;
            }
            if (majorName) {
                return majorName;
            }
            if (positionsName.indexOf('：') !== -1) {
                const parts = positionsName.split('：');
                return parts[parts.length - 1].trim() || positionsName;
            }
            return positionsName || '—';
        },
        fileUrlPath(url) {
            if (!url) return '';
            return String(url).split('?')[0].toLowerCase();
        },
        isPdfUrl(url) {
            return this.fileUrlPath(url).endsWith('.pdf');
        },
        isImageUrl(url) {
            return /\.(jpe?g|png|gif|webp|bmp)$/.test(this.fileUrlPath(url));
        },
        changeFileType: function (event) {
            // console.log(event);
            this.fType = event;
        },
        upNewFileTz(event) {
            const droppedFiles = event.dataTransfer.files;
            if(droppedFiles.length > 0) {
                for(let i=0; i<droppedFiles.length; i++) {
                    this.uploadFile(droppedFiles[i],this.fType);
                }
            }
            event.dataTransfer.files = null;
        },
        upNewFile: function (event) {
            const _f = event.target.files[0];
            if(_f) {
                this.uploadFile(_f,this.fType);
            }
            event.target.value = null;
        },
        pickAttachmentType(item) {
            if (!item) return null;
            return item.attachmentType != null ? item.attachmentType : item.attachment_type;
        },
        pickFileUrl(item) {
            if (!item) return '';
            return item.fileUrl || item.file_url || '';
        },
        pickEducationSegmentOrder(item) {
            if (!item) return null;
            return item.educationSegmentOrder != null
                ? item.educationSegmentOrder
                : item.education_segment_order;
        },
        normalizeEducationRecord(edu) {
            if (!edu) {
                return {};
            }
            return {
                segmentOrder: edu.segmentOrder != null ? edu.segmentOrder : edu.segment_order,
                segmentLabel: edu.segmentLabel || edu.segment_label || '',
                graduatedInstitution: edu.graduatedInstitution || edu.graduated_institution || '',
                major: edu.major || '',
                majorCode: edu.majorCode || edu.major_code || '',
                educationLevel: edu.educationLevel || edu.education_level || '',
                departureDate: edu.departureDate || edu.departure_date,
                isDomestic: edu.isDomestic != null ? edu.isDomestic : edu.is_domestic,
                institutionType: edu.institutionType || edu.institution_type || '',
                qsRanking: edu.qsRanking != null ? edu.qsRanking : edu.qs_ranking,
            };
        },
        getEducationHistoryList() {
            const raw = (this.myJobData && (this.myJobData.educationHistory || this.myJobData.education_history)) || [];
            return raw.map((item) => this.normalizeEducationRecord(item));
        },
        getAttachmentTypeLabel(type, segOrder) {
            const baseMap = {
                1: '身份证正面',
                2: '身份证反面',
                3: '免冠照',
                // 4: '个人简历',
                5: '毕业证',
                6: '学位证',
                7: '学信网学籍验证报告',
                9: '无犯罪记录证明',
                10: '教育部留学服务中心认证',
            };
            const base = baseMap[type] || ('附件类型' + type);
            if ([5, 6, 7, 10].indexOf(type) !== -1 && segOrder != null) {
                const seg = this.printEducationSegments[segOrder];
                const segTitle = seg ? seg.segmentTitle : ('学历段' + (segOrder + 1));
                return segTitle + ' - ' + base;
            }
            return base;
        },
        buildAllAttachmentPreviewList() {
            const files = (this.myJobData && this.myJobData.file) || [];
            const typeOrder = {1: 1, 2: 2, 3: 3, 9: 4, 7: 10, 5: 11, 6: 12, 10: 13, 4: 14};
            const list = files.map((item, index) => {
                const type = this.pickAttachmentType(item);
                const seg = this.pickEducationSegmentOrder(item);
                const url = this.pickFileUrl(item);
                if (!url || type === 8) {
                    return null;
                }
                return {
                    key: 'att-' + index + '-' + type + '-' + (seg != null ? seg : 'g'),
                    type,
                    seg,
                    url,
                    label: this.getAttachmentTypeLabel(type, seg),
                    sort: (typeOrder[type] || 99) * 100 + (seg != null ? seg : 0),
                };
            }).filter(Boolean);
            list.sort((a, b) => a.sort - b.sort);
            this.allAttachmentPreviewList = list;
        },
        resetPersonalAttachmentStatus() {
            this.upStatus = {
                idFront: '未上传',
                idBack: '未上传',
                photo: '未上传',
                criminalRecord: '未上传',
            };
            this.personalAttachmentCount = 0;
        },
        updatePersonalAttachmentCount() {
            let count = 0;
            if (this.upStatus.idFront !== '未上传') count++;
            if (this.upStatus.idBack !== '未上传') count++;
            if (this.upStatus.photo !== '未上传') count++;
            if (this.upStatus.criminalRecord !== '未上传') count++;
            this.personalAttachmentCount = count;
        },
        getSegmentAttachStatus(segIndex, attachmentType) {
            const key = segIndex + '_' + attachmentType;
            return this.segmentAttachMap[key] || '未上传';
        },
        formatAttachUploaded(fileUrl) {
            if (!fileUrl) {
                return '未上传';
            }
            const parts = String(fileUrl).split('.');
            const ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
            return ext ? '已上传 (' + ext + ')' : '已上传';
        },
        formatDepartureYearMonth(dep) {
            return formatGraduationYear(dep);
        },
        mapEducationToPrint(edu, segIndex) {
            const normalized = this.normalizeEducationRecord(edu);
            const isDomestic = normalized.isDomestic;
            const isDomesticYes = isDomestic === 1 || isDomestic === '1';
            const isDomesticNo = isDomestic === 0 || isDomestic === '0';
            let institutionLabel = '院校层级';
            let institutionValue = '';
            if (isDomesticYes) {
                institutionValue = normalized.institutionType || '';
            } else if (isDomesticNo) {
                institutionLabel = '院校2025QS排名';
                const qs = normalized.qsRanking;
                institutionValue = qs != null && qs !== '' ? String(qs) : '';
            }
            const dep = normalized.departureDate;
            const departureText = this.formatDepartureYearMonth(dep);
            return {
                segmentTitle: normalized.segmentLabel || ('学历段' + (segIndex + 1)),
                graduatedInstitution: normalized.graduatedInstitution,
                major: normalized.major,
                majorCode: String(normalized.majorCode || '').trim(),
                educationLevel: normalized.educationLevel,
                departureDate: departureText,
                isDomesticText: isDomesticYes ? '是' : (isDomesticNo ? '否' : ''),
                isDomesticYes,
                isDomesticNo,
                institutionLabel,
                institutionValue,
                attachXuexin: this.getSegmentAttachStatus(segIndex, 7),
                attachGrad: this.getSegmentAttachStatus(segIndex, 5),
                attachDegree: this.getSegmentAttachStatus(segIndex, 6),
                attachStudyAbroad: this.getSegmentAttachStatus(segIndex, 10),
            };
        },
        getExpectedEducationLabels(highestEducation) {
            if (highestEducation === '专科') {
                return ['专科信息'];
            }
            if (highestEducation === '本科') {
                return ['本科信息'];
            }
            if (highestEducation === '硕士研究生') {
                return ['本科信息', '研究生信息'];
            }
            if (highestEducation === '博士研究生') {
                return ['本科信息', '研究生信息', '博士信息'];
            }
            return [];
        },
        buildMainTableEducationRecord(label) {
            const d = this.myJobData || {};
            const institution = d.graduated_institution || d.graduatedInstitution || '';
            let institutionValue = d.institution_type || d.institutionType || '';
            if (!institutionValue && institution) {
                if (school['985'].indexOf(institution) !== -1) {
                    institutionValue = '985';
                } else if (school['211'].indexOf(institution) !== -1) {
                    institutionValue = '211';
                } else if (school['双一流'].indexOf(institution) !== -1) {
                    institutionValue = '双一流';
                } else if (d.education === '专科') {
                    institutionValue = '大学专科';
                } else {
                    institutionValue = '普通本科';
                }
            }
            return {
                segmentLabel: label,
                graduatedInstitution: institution,
                major: d.major || '',
                majorCode: '',
                educationLevel: d.education || '',
                departureDate: d.graduation_time || d.graduationTime,
                isDomestic: 1,
                institutionType: institutionValue,
            };
        },
        matchEducationSegmentLabel(recordLabel, expectedLabel) {
            if (!recordLabel || !expectedLabel) {
                return false;
            }
            if (recordLabel === expectedLabel) {
                return true;
            }
            const aliasMap = {
                '专科信息': ['专科', '专科信息'],
                '本科信息': ['本科', '本科信息'],
                '研究生信息': ['研究生', '研究生信息', '硕士研究生'],
                '博士信息': ['博士', '博士信息', '博士研究生'],
            };
            const aliases = aliasMap[expectedLabel] || [expectedLabel];
            return aliases.indexOf(recordLabel) !== -1;
        },
        resolveEducationRecordForSegment(raw, expectedLabels, label, idx) {
            const list = (raw || []).map((item) => this.normalizeEducationRecord(item));
            if (!list.length) {
                if (label === expectedLabels[expectedLabels.length - 1]) {
                    return this.buildMainTableEducationRecord(label);
                }
                return { segmentLabel: label };
            }
            let matched = null;
            list.forEach((edu) => {
                if (this.matchEducationSegmentLabel(edu.segmentLabel, label)) {
                    matched = edu;
                }
            });
            if (matched) {
                return matched;
            }
            const sorted = list.slice().sort((a, b) => {
                const ao = a.segmentOrder != null ? a.segmentOrder : 0;
                const bo = b.segmentOrder != null ? b.segmentOrder : 0;
                return ao - bo;
            });
            const byOrder = sorted.find((edu) => edu.segmentOrder === idx);
            if (byOrder) {
                return byOrder;
            }
            if (sorted.length === expectedLabels.length && sorted[idx]) {
                return sorted[idx];
            }
            if (sorted.length === 1 && expectedLabels.length > 1 && idx === expectedLabels.length - 1) {
                return sorted[0];
            }
            if (idx === expectedLabels.length - 1) {
                return this.buildMainTableEducationRecord(label);
            }
            return { segmentLabel: label };
        },
        buildFallbackEducationSegments() {
            const d = this.myJobData || {};
            const highest = d.highest_education || d.highestEducation || d.education || '';
            const labelMap = {
                '专科': '专科信息',
                '本科': '本科信息',
                '硕士研究生': '研究生信息',
                '博士研究生': '博士信息',
            };
            const institution = d.graduated_institution || d.graduatedInstitution || '';
            let institutionValue = d.institution_type || d.institutionType || '';
            if (!institutionValue && institution) {
                if (school['985'].indexOf(institution) !== -1) {
                    institutionValue = '985';
                } else if (school['211'].indexOf(institution) !== -1) {
                    institutionValue = '211';
                } else if (school['双一流'].indexOf(institution) !== -1) {
                    institutionValue = '双一流';
                } else if (d.education === '专科') {
                    institutionValue = '大学专科';
                } else {
                    institutionValue = '普通本科';
                }
            }
            const dep = d.graduation_time || d.graduationTime;
            return [this.mapEducationToPrint({
                segmentLabel: labelMap[highest] || '学历信息',
                graduatedInstitution: institution,
                major: d.major || '',
                majorCode: '',
                educationLevel: d.education || '',
                departureDate: dep,
                isDomestic: 1,
                institutionType: institutionValue,
            }, 0)];
        },
        buildPrintEducationSegments() {
            const d = this.myJobData || {};
            const highest = d.highest_education || d.highestEducation || d.education || '';
            const expectedLabels = this.getExpectedEducationLabels(highest);
            const raw = this.getEducationHistoryList();

            if (expectedLabels.length > 0) {
                return expectedLabels.map((label, idx) => {
                    const record = this.resolveEducationRecordForSegment(raw, expectedLabels, label, idx);
                    const merged = Object.assign({ segmentLabel: label }, record);
                    return this.mapEducationToPrint(merged, idx);
                });
            }
            if (raw.length > 0) {
                return raw.slice().sort((a, b) => {
                    const ao = a.segmentOrder != null ? a.segmentOrder : 0;
                    const bo = b.segmentOrder != null ? b.segmentOrder : 0;
                    return ao - bo;
                }).map((edu, idx) => this.mapEducationToPrint(edu, idx));
            }
            return this.buildFallbackEducationSegments();
        },
        normalizeMyJobData() {
            if (!this.myJobData) {
                return;
            }
            const d = this.myJobData;
            if (!d.highest_education && !d.highestEducation && d.education) {
                d.highest_education = d.education;
            }
            if (d.graduation_time && !d.graduationTime) {
                d.graduation_time = moment(d.graduation_time).format('YYYY-MM-DD');
            }
            const entrance = d.entrance_type != null ? d.entrance_type : d.entranceType;
            if (Number(entrance) === 2) {
                d.positionsName = this.formatOperationPositionName(d);
            }
            d.educationHistory = this.getEducationHistoryList();
            this.printEducationSegments = this.buildPrintEducationSegments();
            this.buildAllAttachmentPreviewList();
        },
        getJobInfo: function () {
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/job-applications/currently', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                }).then((res) => {
                    let _d = res.data;
                    if (_d.success) {
                        this.myJobData = _d.data;
                        if (this.myJobData.approvalStatus != null && this.myJobData.approval_status == null) {
                            this.myJobData.approval_status = this.myJobData.approvalStatus;
                        }
                        this.myJobData.created_at = moment(_d.data.created_at).format('yyyy-MM-DD');
                        if(this.myJobData.qys_id) {
                            this.getQysSign(this.myJobData.qys_id);
                        }
                        let sfz = {z: false, f: false};
                        this.segmentAttachMap = {};
                        this.resetPersonalAttachmentStatus();
                        this.myJobData.familyNum = (this.myJobData.family.length+1);
                        this.myJobData.fileNum = this.myJobData.file.length;
                        this.myJobData.file.forEach(item => {
                            const type = this.pickAttachmentType(item);
                            const seg = this.pickEducationSegmentOrder(item);
                            const fileUrl = this.pickFileUrl(item);
                            if (type != null && fileUrl) {
                                const segKey = seg != null ? seg : (
                                    [5, 6, 7, 10].indexOf(type) !== -1 ? 0 : null
                                );
                                if (segKey != null) {
                                    this.segmentAttachMap[segKey + '_' + type] = this.formatAttachUploaded(fileUrl);
                                }
                            }
                            let _type = fileUrl ? fileUrl.split('.') : [];
                            const extText = _type.length ? _type[_type.length - 1] : '';
                            if(type == 1) {
                                sfz.z = true;
                                this.upStatus.idFront = extText ? ('已上传 (' + extText + ')') : '已上传';
                                this.bmFile.bf1 = item;
                            }
                            if(type == 2) {
                                sfz.f = true;
                                this.upStatus.idBack = extText ? ('已上传 (' + extText + ')') : '已上传';
                                this.bmFile.bf2 = item;
                            }
                            if(type == 3) {
                                this.upStatus.photo = extText ? ('已上传 (' + extText + ')') : '已上传';
                                this.bmFile.bf3 = item;
                            }
                            if(type == 4) {
                                this.bmFile.bf4 = item;
                            }
                            if(type == 5) {
                                this.bmFile.bf5 = item;
                            }
                            if(type == 6) {
                                this.bmFile.bf6 = item;
                            }
                            if(type == 7) {
                                this.bmFile.bf7 = item;
                            }
                            if(type == 9) {
                                this.upStatus.criminalRecord = extText ? ('已上传 (' + extText + ')') : '已上传';
                            }
                        })
                        this.updatePersonalAttachmentCount();
                        this.initApplicationFormLockState();
                        this.normalizeMyJobData();
                        this.loadTicketPrintWindow();
                        this.loadSupplementMaterials();
                    }
                }).catch((error) => {
                    // this.$message.error(error);
                    console.log(error)
                    this.$router.push('/pageIndex');
                })
            }
        },
        goToPrintTicketPage() {
            if (this.navigatingToPrint) {
                return;
            }
            this.navigatingToPrint = true;
            validatePrintTicketAccess()
                .then((ok) => {
                    if (ok) {
                        this.$router.push('/pagePrint');
                    }
                })
                .finally(() => {
                    this.navigatingToPrint = false;
                });
        },
        async downloadApplicationFormPdf() {
            if (this.downloadingApplicationForm) {
                return;
            }
            const target = this.$refs.applicationFormMain;
            if (!target) {
                this.$message.warning('报名表内容未就绪');
                return;
            }
            this.downloadingApplicationForm = true;
            try {
                await this.$nextTick();
                const rawName = (this.myJobData && this.myJobData.name) ? String(this.myJobData.name).trim() : '考生';
                const safeName = rawName.replace(/[\\/:*?"<>|]/g, '_') || '考生';
                await exportDomToPdf(target, `${safeName}-报名表.pdf`, { marginMm: 0, scale: 2 });
                this.$message.success('报名表已下载');
            } catch (error) {
                console.error(error);
                this.$message.error('报名表下载失败，请稍后重试');
            } finally {
                this.downloadingApplicationForm = false;
            }
        },
        loadTicketPrintWindow: function () {
            const positionId = this.myJobData.position_id || this.myJobData.positionId;
            if (!positionId || !Cookies.get('reqToKen')) {
                this.ticketPrintStepText = '下载准考证时间另行通知';
                return;
            }
            axios.get('/zhaopinapi/exam-ticket-print-window/effective', {
                headers: { Authorization: Cookies.get('reqToKen') },
                params: { positionId: positionId },
            }).then((res) => {
                const _d = res.data;
                if (_d.success && _d.data) {
                    this.ticketPrintEffective = _d.data;
                    this.ticketPrintStepText = _d.data.stepDisplayText || '下载准考证时间另行通知';
                } else {
                    this.ticketPrintStepText = '下载准考证时间另行通知';
                }
            }).catch(() => {
                this.ticketPrintStepText = '下载准考证时间另行通知';
            });
        },
        loadSupplementMaterials() {
            const applicationId = this.myJobData && this.myJobData.id;
            if (!applicationId || this.currentApprovalStatus !== 3 || !Cookies.get('reqToKen')) {
                this.supplementMaterialFiles = [];
                this.supplementMaterialUploaded = false;
                return;
            }
            axios.get('/zhaopinapi/job-applications/' + applicationId + '/supplement-materials', {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const _d = res.data;
                if (_d.success && _d.data) {
                    this.supplementMaterialUploaded = !!_d.data.uploaded;
                    this.supplementMaterialFiles = Array.isArray(_d.data.files) ? _d.data.files : [];
                } else {
                    this.supplementMaterialUploaded = false;
                    this.supplementMaterialFiles = [];
                }
            }).catch(() => {
                this.supplementMaterialUploaded = false;
                this.supplementMaterialFiles = [];
            });
        },
        onSupplementMaterialButtonClick() {
            if (this.supplementMaterialUploaded) {
                this.supplementViewDialogVisible = true;
                return;
            }
            this.supplementPendingFiles = [];
            this.supplementUploadDialogVisible = true;
        },
        onSupplementUploadDialogClosed() {
            this.supplementPendingFiles = [];
            this.supplementUploadSubmitting = false;
            if (this.$refs.supplementFileInput) {
                this.$refs.supplementFileInput.value = '';
            }
        },
        triggerSupplementFileSelect() {
            if (this.$refs.supplementFileInput) {
                this.$refs.supplementFileInput.click();
            }
        },
        onSupplementFilesSelected(event) {
            const input = event && event.target;
            const selected = input && input.files ? Array.from(input.files) : [];
            if (!selected.length) {
                return;
            }
            const maxSize = 5 * 1024 * 1024;
            const validFiles = [];
            selected.forEach((file) => {
                if (!this.isAllowedSupplementFile(file)) {
                    this.$message.warning('仅支持图片或 PDF：' + file.name);
                    return;
                }
                if (file.size > maxSize) {
                    this.$message.warning('单个文件不能超过 5M：' + file.name);
                    return;
                }
                const duplicated = this.supplementPendingFiles.some((item) => (
                    item.name === file.name && item.size === file.size
                ));
                if (!duplicated) {
                    validFiles.push(file);
                }
            });
            this.supplementPendingFiles = this.supplementPendingFiles.concat(validFiles);
            if (input) {
                input.value = '';
            }
        },
        removeSupplementPendingFile(index) {
            this.supplementPendingFiles.splice(index, 1);
        },
        isAllowedSupplementFile(file) {
            if (!file || !file.name) {
                return false;
            }
            const name = file.name.toLowerCase();
            if (name.endsWith('.pdf')) {
                return true;
            }
            if (file.type && file.type.startsWith('image/')) {
                return true;
            }
            return /\.(png|jpe?g|bmp|gif|webp)$/i.test(name);
        },
        formatFileSize(size) {
            const bytes = Number(size);
            if (!bytes || bytes <= 0) {
                return '—';
            }
            if (bytes < 1024) {
                return bytes + ' B';
            }
            if (bytes < 1024 * 1024) {
                return (bytes / 1024).toFixed(1) + ' KB';
            }
            return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
        },
        async uploadSupplementFileToCloud(file) {
            const options = {
                bucket: 'webimg',
                expiration: Math.floor(new Date().getTime() / 1000) + 86400,
                'save-key': '/luanZp/{year}/{mon}/{day}/upload_{random32}{.suffix}',
            };
            const policy = window.btoa(JSON.stringify(options));
            const signature = md5(policy + '&' + 'dpNJGtx3fMUHooMfVfaPqofJbFE=');
            const formData = new FormData();
            formData.append('file', file);
            formData.append('key', file.name);
            formData.append('policy', policy);
            formData.append('OSSAccessKeyId', 'mp12345.com');
            formData.append('signature', signature);
            const response = await axios.post('https://v0.api.upyun.com/webimg', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            const url = response.data.url
                ? ('https://webimg.mp12345.com' + response.data.url)
                : response.data.url;
            return {
                fileName: file.name,
                fileUrl: url,
                fileSize: file.size,
            };
        },
        async submitSupplementMaterials() {
            if (this.supplementUploadSubmitting) {
                return;
            }
            if (!this.supplementPendingFiles.length) {
                this.$message.warning('请先选择要上传的文件');
                return;
            }
            const applicationId = this.myJobData && this.myJobData.id;
            if (!applicationId) {
                this.$message.error('报名信息不存在');
                return;
            }
            this.supplementUploadSubmitting = true;
            try {
                const uploaded = [];
                for (const file of this.supplementPendingFiles) {
                    const item = await this.uploadSupplementFileToCloud(file);
                    if (!item.fileUrl) {
                        throw new Error('文件上传失败：' + file.name);
                    }
                    uploaded.push(item);
                }
                const res = await axios.post(
                    '/zhaopinapi/job-applications/' + applicationId + '/supplement-materials',
                    { files: uploaded },
                    { headers: { Authorization: Cookies.get('reqToKen') } },
                );
                const _d = res.data;
                if (_d.success) {
                    this.$message.success(_d.message || '补充资料上传成功');
                    this.supplementUploadDialogVisible = false;
                    this.loadSupplementMaterials();
                } else {
                    this.$message.error(_d.message || '补充资料上传失败');
                }
            } catch (error) {
                console.error(error);
                const msg = (error && error.response && error.response.data && error.response.data.message)
                    || (error && error.message)
                    || '补充资料上传失败，请稍后重试';
                this.$message.error(msg);
            } finally {
                this.supplementUploadSubmitting = false;
            }
        },
        getQysSign: function (id) {
            axios.get('/zhaopinapi/qys/querySeal.json', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: {qysId: id}
            }).then((res) => {
                console.log(res);
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
        async uploadFile(f,_type) {
            if (!f) {
                alert('请选择一个文件！');
                return;
            }
            var options = {
                bucket: 'webimg',
                expiration: Math.floor(new Date().getTime() / 1000) + 86400,
                'save-key': '/luanZp/{year}/{mon}/{day}/upload_{random32}{.suffix}'
            };
            var policy = window.btoa(JSON.stringify(options));
            var signature = md5(policy + '&' + 'dpNJGtx3fMUHooMfVfaPqofJbFE=');

            const formData = new FormData();
            formData.append('file', f); // 将文件添加到表单数据中
            formData.append('key', f.name); // 设置你的对象键（例如文件名）
            formData.append('policy', policy); // 设置你的策略，通常是base64编码的JSON策略字符串
            formData.append('OSSAccessKeyId', 'mp12345.com'); // 你的Access Key ID
            formData.append('signature', signature); // 签名，使用Access Key Secret和策略生成的签名

            return await axios.post('https://v0.api.upyun.com/webimg', formData, {
                headers: {'Content-Type': 'multipart/form-data'}
            })
                .then(response => {
                    response.data.url = response.data.url ? ('https://webimg.mp12345.com' + response.data.url) : response.data.url;
                    response.data.fileName = f.name;
                    if(_type == 1) {
                        this.files.f1 = response.data;
                    } else if(_type == 5) {
                        this.files.f5 = response.data;
                    } else if(_type == 7) {
                        this.files.f7 = response.data;
                    } else if(_type == 2 || _type == 3 || _type == 4 || _type == 6) {
                        this.files['f'+_type] = response.data;
                    }
                })
                .catch(error => {
                    // this.$message.error(error);
                    console.log(error)
                    return null; // 或者抛出错误，取决于你的需求
                });
        },
        updateFiles: function () {
            if (!this.files['f' + this.fType] || !this.files['f' + this.fType].url) {
                this.$message.error('请先上传文件！');
                return;
            }
            axios.post('/zhaopinapi/job-application-attachments', {
                applicationId: this.myJobData.id,
                attachmentType: this.fType,
                fileUrl: this.files['f' + this.fType].url
            },{
                headers: {'Authorization': Cookies.get('reqToKen')}
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    // console.log(_d)
                    this.$message.success('附件已更新！');
                    // 清空已上传的文件，允许继续上传
                    this.files['f' + this.fType] = null;
                    // 重新获取最新数据，更新页面显示
                    this.getJobInfo();
                }
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
        confirmQm: function () {
            this.confirmDialogVisible = false;
            this.getUserAuthId(this.myJobData.id);
        },
        dialogQm: function () {
            this.confirmDialogVisible = true;
            this.convertImagesToBase64();
        },
        getUserAuthId: function (id) {
            axios.get('/zhaopinapi/qys/getUserAuthIdentityRequest.json', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: {applicationsId: id}
            }).then((res) => {
                let {result, reason, authUrl} = res.data.data;
                if(reason){
                    this.$message(reason);
                    return;
                }
                if(authUrl){
                    window.open(authUrl,'_blank');
                }
                if (result) {
                    this.$message("已认证");
                }
                this.makeUserAuth(id);
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
        makeUserAuth: function (id) {
            axios.get('/zhaopinapi/qys/getSealManage.json', {
                headers: {'Authorization': Cookies.get('reqToKen')},
                params: {applicationsId: id}
            }).then((res) => {
                console.log(res);
                if(res.data.success) {
                    let _d = res.data.data;
                    window.open(_d.pageUrl,'_blank');
                    this.gotoSign();
                }
            }).catch((error) => {
                // this.$message.error(error);
                console.log(error)
            })
        },
        getPrintFormCss() {
            return `<style type="text/css">.jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
            @media (max-width: 1400px) and (min-width: 1300px) {
                .jobMain{width: 90%;  margin: 0 auto;}
            }
            @media (max-width: 1300px) {
                .jobMain{width: 100%; min-width: 1150px;}
            }
            .jobContent{width: 210mm; margin: 0 auto;}
            .jobContent-t{padding-bottom: 20px;}
            .jobContent-tle{font-size: 18px; color: #1E2939; font-weight: bold; line-height: 30px; float: left;}
            .jobContent-tr{float: right;}
            .jobContent-tr-btn{float: right; padding-left: 10px;}
            .jobStep{position: relative;}
            .jobStep-bar{height: 4px; background: #F3F4F6; border-radius: 2px; position: absolute; width: 100%; left: 0; top: 24px;}
            .jobStep-list{}
            .jobStep-li{text-align: center;}
            .jobStep-icon-success{font-size: 36px; color: #00A63E;}
            .jobStep-text-success{font-size: 14px; color: #00A63E; font-weight: bold;}
            .jobStep-icon-error{font-size: 36px; color: #E7000B;}
            .jobStep-text-error{font-size: 14px; color: #E7000B; font-weight: bold;}
            .jobStep-icon-check{font-size: 36px; color: #155DFC;}
            .jobStep-text-check{font-size: 14px; color: #155DFC; font-weight: bold;}
            .icon-number{width: 32px; height: 32px; border-radius: 18px; line-height: 32px; display: inline-block; vertical-align: middle; font-style: normal; text-align: center; font-size: 16px; font-weight: bold; background: #E5E7EB; color: #99A1AF;}
            .jobStep-icon-default{font-size: 36px; color: #99A1AF;}
            .jobStep-text-default{font-size: 14px; color: #99A1AF; font-weight: bold;}
            .jobStep-icon-check .icon-number{background: #155DFC; color: #fff;}
            .print-time{padding-bottom: 15px;}
            .pageRegisterLink{}
            .page-head{padding-top: 24px; background-color: #fff;}
            .page-main{padding-top: 64px;}
            .jobStep-print-time{border-radius: 4px; border: 1px solid #DBEAFE; background: #EFF6FF; font-size: 12px; color: #155DFC; padding: 8px 16px; display: inline-block;}
            .jobAddInformation{border-radius: 10px; border: 1px solid #FFC9C9; background: #FFF; margin-bottom: 32px; box-shadow: 0 0 0 4px #FEF2F2, 0 20px 25px -5px rgba(0, 0, 0, 0.10), 0 8px 10px -6px rgba(0, 0, 0, 0.10);}
            .jobAddInformation-top{padding: 24px 24px 24px 24px; border-bottom: none; border-top: 6px solid #E7000B; border-top-left-radius: 10px; border-top-right-radius: 10px;}
            .jAI-tlef{width: 48px; float: left;}
            .jAI-trig{margin-left: 68px;}
            .jAI-tlef-icon{width: 48px; height: 48px; text-align: center; border-radius: 24px; opacity: 0.5078; background: #FFE2E2; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 24px; color: #E7000B;}
            .jAI-trig-t{height: 28px; padding-bottom: 9px;}
            .jAI-trig-tle{font-size: 20px; color: #101828; font-weight: bold; line-height: 28px; float: left;}
            .jAI-trig-time{float: right; border-radius: 12px; opacity: 0.5078; background: #FFE2E2; padding: 2px 12px; height: 24px; line-height: 24px; color: #C10007; font-weight: bold;}
            .jAI-trig-intro{color: #4A5565; line-height: 22px;}
            .jAI-trig-tips{border-radius: 10px; border: 1px solid #FFE2E2; background: #FEF2F2; padding: 21px;}
            .jAI-trig-tip1{color: #9F0712; font-size: 16px; font-weight: bold; line-height: 32px;}
            .jAI-trig-tip2{color: #1E2939; font-size: 16px; line-height: 28px; padding-left: 20px;}
            .jAI-trig-tip3{color: #E7000B; font-size: 14px; line-height: 32px; font-weight: bold;}
            .jobAddInformation-bottom{background: #F9FAFB;}
            .jAI-upload{width: 50%; float: left; padding: 32px; border-right: 1px solid #F3F4F6; box-sizing: border-box;}
            .jAI-upload-t{font-weight: bold; color: #101828; line-height: 24px; font-size: 16px; padding-bottom: 12px;}
            .jAI-upload-tle{float: left;}
            .jAI-upload-icon{color: #E7000B;}
            .jAI-upload-box{height: 188px; border-radius: 10px; border: 2px solid #D1D5DC; background: #FFF; text-align: center; position: relative; overflow: hidden;}
            .jAI-upload-btn{width: 1000px; height: 600px; font-size: 200px; position: absolute; right: 0; top: 0; z-index: 2; opacity: 0; filter: alpha(opacity=0); cursor: pointer;}
            .jAI-upload-tip1{font-size: 14px; font-weight: bold; line-height: 30px;}
            .jAI-upload-tip2{font-size: 14px; line-height: 30px; color: #99A1AF;}
            .jAI-form{padding: 32px; min-height: 292px; box-sizing: border-box; margin-left: 50%; background: #fff;}
            .jAI-form-t{height: 28px; line-height: 24px; color: #101828; font-weight: bold; font-size: 16px;}
            .jAI-form-list{border-bottom: 1px solid #F3F4F6; padding-top: 16px;}
            .jAI-form-li{margin-bottom: 12px; border-radius: 4px; padding: 0 12px; height: 46px; line-height: 46px;}
            .jAI-form-linew{border: 1px solid #DBEAFE; background: #EFF6FF;}
            .jAI-form-liold{border: 1px solid #E5E7EB; opacity: 0.6; background: #FFF; color: #6A7282;}
            .jAI-form-liold .jAI-upload-lir{color: #99A1AF; float: right;}
            .jAI-form-linew .jAI-upload-lir{border-radius: 4px; background: #BEDBFF; height: 20px; line-height: 20px; padding: 2px 8px; float: right; color: #193CB8; margin-top: 13px;}
            .jAI-form-btn{border-radius: 10px; display: block; cursor: pointer; width: 100%; background: #E7000B; color: #fff; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10); font-size: 16px; font-weight: bold; border: none; height: 48px; line-height: 48px;}
            .jAI-form-btn:hover{background: #C10007;}
            .print-main{padding: 30px 60px; background: #fff;}
            .print-mt{height: 85px; border-bottom: 2px solid #E7000B;}
            .job-t-table{width: 100%; border: none; border-collapse: collapse; border-spacing: 0;}
            .job-t-table td{border: none; }
            .print-mt-logo{width: 36px; height: 36px; padding: 6px; float: left;}
            .print-mt-logo img{width: 36px; height: 36px; border: none;}
            .print-mt-mid-cell{vertical-align: middle; padding-left: 16px;}
            .print-mt-mid-t{display: flex; flex-direction: column; justify-content: center; max-width: 100%; min-height: 56px; font-family: Arial, "Microsoft YaHei", sans-serif;}
            .print-mt-mid-title{color: #101828; font-size: 22px; font-weight: 900; line-height: 1.2; letter-spacing: 0.1em;}
            .print-mt-mid-major{margin-top: 4px; color: #364153; font-size: 15px; font-weight: 700; line-height: 1.35; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}
            .print-mt-mid-major--md{font-size: 13px;}
            .print-mt-mid-major--sm{font-size: 12px;}
            .print-mt-mid-major--xs{font-size: 11px; line-height: 1.25;}
            .print-mt-mid-major--wrap{white-space: normal; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; text-overflow: clip;}
            .print-mt-mid-subt{color: #6A7282; font-family: Arial; font-size: 12px; font-weight: 400; line-height: 16px; letter-spacing: 1.2px;}
            .print-mt-r{float: right;}
            .print-msubt{padding: 24px 0 18px 0;}
            .print-msubt-l{float: left;}
            .print-msubt-lw{color: #4A5565; font-size: 14px; line-height: 22px; padding: 0; margin: 0;}
            .print-msubt-lw B{color: #101828;}
            .print-msubt-r{float: right; padding-top: 15px;}
            .print-msubt-rtag{font-size: 12px; font-weight: bold; color: #364153 !important;}
            .print-mm{padding-bottom: 18px;}
            .print-mb{text-align: center; color: #99A1AF; font-size: 12px; line-height: 20px;}
            .print-mtable{width: 100%; border-spacing: 0; border-collapse: collapse; border: 2px solid #99A1AF;}
            .print-mtable td{border: 1px solid #D1D5DC; padding: 2px 8px; font-size: 12px; line-height: 20px; background: #fff; color: #1E2939; text-align: center;}
            .print-mtable td.t1{background: #F3F4F6; text-align: left; font-size: 14px; color: #1E2939; font-weight: bold;}
            .print-mtable td.print-edu-seg-title{background: #FAFAFA; font-size: 13px; color: #364153; padding-left: 28px;}
            .print-mtable td.t2{background: #F9FAFB;}
            .print-mtable td.lw{text-align: left;}
            .tdIcon{font-size: 16px; color: #E7000B; margin-right: 10px;}
            .print-mtable td.bstatus{border-top: 2px solid #99A1AF; background: #FEF2F2; padding: 12px;}
            .bstatus-lef{float: left;}
            .bstatus-rig{float: right; text-align: right;}
            .bstatus-tle{font-size: 12px; line-height: 20px; font-weight: bold; color: #364153;}
            .bstatus-lb{font-size: 14px; font-weight: bold; color: #00A63E;}
            .bstatus-lb-ing{font-size: 14px; font-weight: bold; color: #007bff;}
            .bstatus-lb-no{font-size: 14px; font-weight: bold; color: #E7000B;}
    .bstatus-lb-pending{font-size: 14px; font-weight: bold; color: #D97706;}
    .regJob-sign-tip{color: #6A7282; font-size: 14px; line-height: 22px; padding-bottom: 12px;}
            .print-avatar{width: 96px; height: 128px; border: 1px solid #E5E7EB;}
            .print-commitment{padding: 8px 24px;}
            .print-commitment-t{line-height: 30px; font-weight: bold; font-size: 14px;}
            .print-commitment-b{padding-left: 24px; color: #4A5565;}
            .print-commitment-signb{padding: 20px 32px 15px 0; text-align: right;}
            .print-commitment-signbtip{float: right; line-height: 40px; font-weight: bold; color: #1E2939;}
            .print-commitment-signline{ width: 150px; height: 60px; float: right; line-height: 20px; font-weight: bold; color: #1E2939; border-bottom: 1px solid #333; text-align: center;}
            .print-commitment-signline img{ width: 150px; height: 55px;}
            .bm-file-tle{padding-top: 10px;}
            .bm-file-p{padding: 10px 0; text-align: center;}
            .bm-file-p img{border: none; max-width: 100%;}
            .bm-file-iframe{border: none; max-width: 100%; min-height: 600px; vertical-align: top;}
            .bm-file-fallback{padding: 24px 0; font-size: 14px;}
            .bm-file-fallback a{color: #E7000B;}
            .bm-file-name{font-size: 20px; text-align: center; padding: 30px 0;}
            .dragDom{padding: 20px 0; border: 2px dashed #D9D9D9; text-align: center; margin-bottom: 15px; position: relative;}
            .dragDomP img{height: 100%;}
            .dragDom-t3{font-size: 14px; color: #3E3E3E; text-align: center; line-height: 20px; position: absolute; width: 100%; height: 100px; left: 0; top: 40px;}
            .regJob-dom{padding: 20px 0 20px 0;}
            .regJob-tle{line-height: 30px; font-size: 28px; color: #323232; padding: 16px 0;}
            .regJob-b{padding-top: 16px; border-top: 1px solid #D9D9D9;}
            .clearfix:after,.clearfix:before{
                clear: both;
                content: "";
                display: block;
                line-height: 0;
            }</style>`;
        },
        extractSignImgFromSavedHtml(html) {
            if (!html) {
                return '';
            }
            const match = String(html).match(/print-commitment-signline[\s\S]*?<img[^>]+src="([^"]+)"/i);
            return match ? match[1] : '';
        },
        initApplicationFormLockState() {
            const d = this.myJobData || {};
            const savedHtml = d.application_html || d.applicationHtml || '';
            const status = Number(d.approval_status);
            if (savedHtml || status >= 2) {
                this.applicationFormLocked = true;
                this.signLocked = true;
                const savedSign = this.extractSignImgFromSavedHtml(savedHtml);
                if (savedSign) {
                    this.signImgSrc = savedSign;
                }
            }
        },
        convertImagesToBase64Async() {
            if (!this.$refs.toPdf) {
                return Promise.resolve();
            }
            const images = this.$refs.toPdf.querySelectorAll('img');
            const tasks = [];
            images.forEach((img) => {
                if (!img.src || img.src.indexOf('data:') === 0) {
                    return;
                }
                // 证件照、附件等已在 CDN 上，转 base64 会使提交体暴增并触发 413，保留原 URL
                if (/^https?:\/\//i.test(img.src)) {
                    return;
                }
                tasks.push(new Promise((resolve) => {
                    const image = new Image();
                    image.crossOrigin = 'anonymous';
                    image.onload = function () {
                        try {
                            const canvas = document.createElement('canvas');
                            canvas.width = image.width;
                            canvas.height = image.height;
                            const ctx = canvas.getContext('2d');
                            ctx.drawImage(image, 0, 0, image.width, image.height);
                            img.src = canvas.toDataURL('image/png');
                        } catch (e) {
                            // 跨域图片无法转 base64 时保留原链接
                        }
                        resolve();
                    };
                    image.onerror = function () {
                        resolve();
                    };
                    image.src = img.src + (img.src.indexOf('?') >= 0 ? '&' : '?') + 'v=' + Math.random();
                }));
            });
            return Promise.all(tasks);
        },
        gotoSign: async function () {
            if (this.savingApplicationForm) {
                return;
            }
            if (this.applicationFormLocked) {
                return;
            }
            if (!this.signImgSrc || !this.signLocked) {
                this.$alert('请先签名并点击「确认签名」', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                });
                return;
            }
            if (!this.$refs.toPdf) {
                this.$message.error('报名表内容未就绪');
                return;
            }
            this.savingApplicationForm = true;
            try {
                await this.convertImagesToBase64Async();
                await this.$nextTick();
                const html = this.$refs.toPdf.innerHTML;
                const applicationHtml = html + this.getPrintFormCss();
                const payloadKb = Math.round((JSON.stringify({ applicationHtml }).length / 1024) * 10) / 10;
                if (payloadKb > 8192) {
                    console.warn('[save-signed-form] 提交体约 ' + payloadKb + ' KB，若失败请检查网关/Nginx client_max_body_size');
                }
                const res = await axios.post('/zhaopinapi/job-applications/' + this.myJobData.id + '/save-signed-form', {
                    applicationHtml,
                }, {
                    headers: { Authorization: Cookies.get('reqToKen') },
                    maxContentLength: Infinity,
                    maxBodyLength: Infinity,
                });
                const result = res.data;
                if (result && (result.success === true || result.code === 200)) {
                    this.applicationFormLocked = true;
                    this.myJobData.approval_status = 2;
                    this.myJobData.application_html = applicationHtml;
                    this.$alert('报名表已提交，已进入资格审查环节，信息已锁定不可修改', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                    });
                    this.getJobInfo();
                } else {
                    this.$alert(result.message || '保存失败', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                    });
                }
            } catch (error) {
                let msg = (error.response && error.response.data && error.response.data.message)
                    || error.message
                    || '保存失败';
                if (error.response && error.response.status === 413) {
                    msg = '提交数据过大（HTTP 413），请联系管理员检查 Nginx 的 client_max_body_size 与后端 Tomcat 配置；若已调整仍失败，请刷新后重试。';
                }
                this.$alert(msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                });
            } finally {
                this.savingApplicationForm = false;
            }
        },
        convertImagesToBase64() {
            const images = this.$refs.toPdf.querySelectorAll('img'); // 获取所有img元素
            images.forEach(img => {
                if(img.src.indexOf("https") != -1) {
                    const image = new Image();
                    image.src = img.src + '?v=' + Math.random();
                    image.crossOrigin = '*'; // 如果图片跨域，需要设置这个属性
                    image.onload = function(){
                        var canvas = document.createElement("canvas");
                        canvas.width = image.width;
                        canvas.height = image.height;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(image, 0, 0, image.width, image.height);
                        //图片的格式
                        var dataURL = canvas.toDataURL("image/png");
                        img.src = dataURL;
                    };
                }
            });
        },
        // 清空画布
        signReset () {
            if (this.signLocked) {
                return;
            }
            this.$refs.esign.reset();
            this.signImgSrc = "";
        },
        // 生成签名的 base64 并锁定画布
        signGenerate () {
            if (this.signLocked || !this.$refs.esign) {
                return;
            }
            this.$refs.esign.generate().then((res) => {
                this.signImgSrc = res;
                this.signLocked = true;
                this.$alert('签名完成，请点击：保存报名表按钮', '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                });
            }).catch(() => {
                this.$alert('请先签名', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                });
            });
        },
        // 附：base64转化成图片
        base64ImgtoFile(dataurl, fileName='file') {
            const arr = dataurl.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const suffix = mime.split('/')[1]
            const bstr = atob(arr[1]);
            let n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], `${fileName}.${suffix}`, { type: mime });
        },
    },
}
</script>

<style scoped>
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .jobContent{width: 210mm; margin: 0 auto;}
    .jobContent-t{padding-bottom: 20px;}
    .jobContent-tle{font-size: 18px; color: #1E2939; font-weight: bold; line-height: 30px; float: left;}
    .jobContent-tr{float: right;}
    .jobContent-tr-btn{float: right; padding-left: 10px;}
    .jobStep{position: relative;}
    .jobStep-bar{height: 4px; background: #F3F4F6; border-radius: 2px; position: absolute; width: 100%; left: 0; top: 24px;}
    .jobStep-list{}
    .jobStep-li{text-align: center;}
    .jobStep-icon-success{font-size: 36px; color: #00A63E;}
    .jobStep-text-success{font-size: 14px; color: #00A63E; font-weight: bold;}
    .jobStep-icon-error{font-size: 36px; color: #E7000B;}
    .jobStep-text-error{font-size: 14px; color: #E7000B; font-weight: bold;}
    .jobStep-icon-check{font-size: 36px; color: #155DFC;}
    .jobStep-text-check{font-size: 14px; color: #155DFC; font-weight: bold;}
    .icon-number{width: 32px; height: 32px; border-radius: 18px; line-height: 32px; display: inline-block; vertical-align: middle; font-style: normal; text-align: center; font-size: 16px; font-weight: bold; background: #E5E7EB; color: #99A1AF;}
    .jobStep-icon-default{font-size: 36px; color: #99A1AF;}
    .jobStep-text-default{font-size: 14px; color: #99A1AF; font-weight: bold;}
    .jobStep-icon-check .icon-number{background: #155DFC; color: #fff;}
    .print-time{padding-bottom: 15px;}
    .pageRegisterLink{}
    .page-head{padding-top: 24px; background-color: #fff;}
    .page-main{padding-top: 64px;}
    .jobStep-print-time{border-radius: 4px; border: 1px solid #DBEAFE; background: #EFF6FF; font-size: 12px; color: #155DFC; padding: 8px 16px; display: inline-block;}

    .jobContent--supplement{width: 92%; max-width: 980px; margin: 0 auto; padding: 0 12px; box-sizing: border-box;}

    .jobAddInformation{border-radius: 10px; border: 1px solid #FFC9C9; background: #FFF; margin-bottom: 32px; box-shadow: 0 0 0 4px #FEF2F2, 0 20px 25px -5px rgba(0, 0, 0, 0.10), 0 8px 10px -6px rgba(0, 0, 0, 0.10);}
    .jobAddInformation-top{padding: 24px 24px 24px 24px; border-bottom: none; border-top: 6px solid #E7000B; border-top-left-radius: 10px; border-top-right-radius: 10px;}
    .jAI-tlef{width: 48px; float: left;}
    .jAI-trig{margin-left: 68px;}
    .jAI-tlef-icon{width: 48px; height: 48px; text-align: center; border-radius: 24px; opacity: 0.5078; background: #FFE2E2; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 24px; color: #E7000B;}
    .jAI-trig-t{height: 28px; padding-bottom: 9px;}
    .jAI-trig-tle{font-size: 20px; color: #101828; font-weight: bold; line-height: 28px; float: left;}
    .jAI-trig-time{float: right; border-radius: 12px; opacity: 0.5078; background: #FFE2E2; padding: 2px 12px; height: 24px; line-height: 24px; color: #C10007; font-weight: bold;}
    .jAI-trig-intro{color: #4A5565; line-height: 22px;}
    .jAI-trig-tips{border-radius: 10px; border: 1px solid #FFE2E2; background: #FEF2F2; padding: 21px;}
    .jAI-trig-tip1{color: #9F0712; font-size: 16px; font-weight: bold; line-height: 32px;}
    .jAI-trig-tip2{color: #1E2939; font-size: 16px; line-height: 28px; padding-left: 20px;}
    .jAI-trig-tip3{color: #E7000B; font-size: 14px; line-height: 32px; font-weight: bold;}
    .jobAddInformation-bottom{background: #F9FAFB;}
    .jAI-upload{width: 50%; float: left; padding: 32px; border-right: 1px solid #F3F4F6; box-sizing: border-box;}
    .jAI-upload-t{font-weight: bold; color: #101828; line-height: 24px; font-size: 16px; padding-bottom: 12px;}
    .jAI-upload-tle{float: left;}
    .jAI-upload-icon{color: #E7000B;}
    .jAI-upload-box{height: 188px; border-radius: 10px; border: 2px solid #D1D5DC; background: #FFF; text-align: center; position: relative; overflow: hidden;}
    .jAI-upload-btn{width: 1000px; height: 600px; font-size: 200px; position: absolute; right: 0; top: 0; z-index: 2; opacity: 0; filter: alpha(opacity=0); cursor: pointer;}
    .jAI-upload-tip1{font-size: 14px; font-weight: bold; line-height: 30px;}
    .jAI-upload-tip2{font-size: 14px; line-height: 30px; color: #99A1AF;}
    .jAI-form{padding: 32px; min-height: 292px; box-sizing: border-box; margin-left: 50%; background: #fff;}
    .jAI-form-t{height: 28px; line-height: 24px; color: #101828; font-weight: bold; font-size: 16px;}
    .jAI-form-list{border-bottom: 1px solid #F3F4F6; padding-top: 16px;}
    .jAI-form-li{margin-bottom: 12px; border-radius: 4px; padding: 0 12px; height: 46px; line-height: 46px;}
    .jAI-form-linew{border: 1px solid #DBEAFE; background: #EFF6FF;}
    .jAI-form-liold{border: 1px solid #E5E7EB; opacity: 0.6; background: #FFF; color: #6A7282;}
    .jAI-form-liold .jAI-upload-lir{color: #99A1AF; float: right;}
    .jAI-form-linew .jAI-upload-lir{border-radius: 4px; background: #BEDBFF; height: 20px; line-height: 20px; padding: 2px 8px; float: right; color: #193CB8; margin-top: 13px;}
    .jAI-form-btn{border-radius: 10px; display: block; cursor: pointer; width: 100%; background: #E7000B; color: #fff; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10); font-size: 16px; font-weight: bold; border: none; height: 48px; line-height: 48px;}
    .jAI-form-btn:hover{background: #C10007;}

    .print-main{padding: 30px 60px; background: #fff;}
    .print-mt{height: 85px; border-bottom: 2px solid #E7000B;}
    .job-t-table{width: 100%; border: none; border-collapse: collapse; border-spacing: 0;}
    .job-t-table td{border: none; }
    .print-mt-logo{width: 36px; height: 36px; padding: 6px; float: left;}
    .print-mt-logo img{width: 36px; height: 36px; border: none;}
    .print-mt-mid-cell{vertical-align: middle; padding-left: 16px;}
    .print-mt-mid-t{display: flex; flex-direction: column; justify-content: center; max-width: 100%; min-height: 56px; font-family: Arial, "Microsoft YaHei", sans-serif;}
    .print-mt-mid-title{color: #101828; font-size: 22px; font-weight: 900; line-height: 1.2; letter-spacing: 0.1em;}
    .print-mt-mid-major{margin-top: 4px; color: #364153; font-size: 15px; font-weight: 700; line-height: 1.35; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}
    .print-mt-mid-major--md{font-size: 13px;}
    .print-mt-mid-major--sm{font-size: 12px;}
    .print-mt-mid-major--xs{font-size: 11px; line-height: 1.25;}
    .print-mt-mid-major--wrap{white-space: normal; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; text-overflow: clip;}
    .print-mt-mid-subt{color: #6A7282; font-family: Arial; font-size: 12px; font-weight: 400; line-height: 16px; letter-spacing: 1.2px;}
    .print-mt-r{float: right;}
    .print-msubt{padding: 24px 0 18px 0;}
    .print-msubt-l{float: left;}
    .print-msubt-lw{color: #4A5565; font-size: 14px; line-height: 22px; padding: 0; margin: 0;}
    .print-msubt-lw B{color: #101828;}
    .print-msubt-r{float: right;}
    .print-msubt-rtag{font-size: 12px; font-weight: bold; color: #364153 !important;}
    .print-mm{padding-bottom: 18px;}
    .print-mb{text-align: center; color: #99A1AF; font-size: 12px; line-height: 20px;}
    .print-mtable{width: 100%; border-spacing: 0; border-collapse: collapse; border: 2px solid #99A1AF;}
    .print-mtable td{border: 1px solid #D1D5DC; padding: 2px 8px; font-size: 12px; line-height: 20px; background: #fff; color: #1E2939; text-align: center;}
    .print-mtable td.t1{background: #F3F4F6; text-align: left; font-size: 14px; color: #1E2939; font-weight: bold;}
    .print-mtable td.print-edu-seg-title{background: #FAFAFA; font-size: 13px; color: #364153; padding-left: 28px;}
    .print-mtable td.t2{background: #F9FAFB;}
    .print-mtable td.lw{text-align: left;}
    .tdIcon{font-size: 16px; color: #E7000B; margin-right: 10px;}
    .print-mtable td.bstatus{border-top: 2px solid #99A1AF; background: #FEF2F2; padding: 12px;}
    .bstatus-lef{float: left;}
    .bstatus-rig{float: right; text-align: right;}
    .bstatus-tle{font-size: 12px; line-height: 20px; font-weight: bold; color: #364153;}
    .bstatus-lb{font-size: 14px; font-weight: bold; color: #00A63E;}
    .bstatus-lb-ing{font-size: 14px; font-weight: bold; color: #007bff;}
    .bstatus-lb-no{font-size: 14px; font-weight: bold; color: #E7000B;}
    .bstatus-lb-pending{font-size: 14px; font-weight: bold; color: #D97706;}
    .regJob-sign-tip{color: #6A7282; font-size: 14px; line-height: 22px; padding-bottom: 12px;}
    .print-avatar{width: 96px; height: 128px; border: 1px solid #E5E7EB;}
    .print-commitment{padding: 8px 24px;}
    .print-commitment-t{line-height: 30px; font-weight: bold; font-size: 14px;}
    .print-commitment-b{padding-left: 24px; color: #4A5565;}
    .print-commitment-signb{padding: 20px 32px 15px 0; text-align: right;}
    .print-commitment-signbtip{float: right; line-height: 40px; font-weight: bold; color: #1E2939;}
    .print-commitment-signline{ width: 150px; height: 60px; float: right; line-height: 20px; font-weight: bold; color: #1E2939; border-bottom: 1px solid #333; text-align: center;}
    .print-commitment-signline img{ width: 150px; height: 55px;}

    .bm-file-tle{padding-top: 10px;}
    .bm-file-p{padding: 10px 0; text-align: center;}
    .bm-file-p img{border: none; max-width: 100%;}
    .bm-file-iframe{border: none; max-width: 100%; min-height: 600px; vertical-align: top;}
    .bm-file-fallback{padding: 24px 0; font-size: 14px;}
    .bm-file-fallback a{color: #E7000B;}
    .bm-file-name{font-size: 20px; text-align: center; padding: 30px 0;}

    .dragDom{padding: 20px 0; border: 2px dashed #D9D9D9; text-align: center; margin-bottom: 15px; position: relative;}
    .dragDomP{height: 80px;}
    .dragDomP img{height: 100%;}
    .dragDom-t3{font-size: 14px; color: #3E3E3E; text-align: center; line-height: 20px; position: absolute; width: 100%; height: 80px; left: 0; top: 30px;}
    .regJob-dom{padding: 20px;}
    .sign-area{position: relative;}
    .sign-area--locked .dragDom{pointer-events: none; cursor: not-allowed; opacity: 0.92;}
    .sign-area--locked::after{
        content: '签名已确认';
        position: absolute;
        right: 12px;
        top: 12px;
        padding: 4px 10px;
        border-radius: 4px;
        background: rgba(0, 166, 62, 0.12);
        color: #00A63E;
        font-size: 12px;
        font-weight: bold;
        pointer-events: none;
    }
    .regJob-tle{line-height: 30px; font-size: 28px; color: #323232; padding: 16px 0;}
    .regJob-b{padding-top: 16px; border-top: 1px solid #D9D9D9;}

    .bstatus-comment{margin-top: 8px; font-size: 13px; line-height: 22px; color: #364153; max-width: 480px; white-space: pre-wrap; word-break: break-word;}
    .bstatus-comment-label{font-weight: bold; color: #101828;}
    .checkRecords{background: #fef2f2; border: 2px solid #9aa1ae; padding: 15px;}

    .supplement-material-tip{color: #101828; font-size: 15px; line-height: 24px; font-weight: bold; margin-bottom: 8px;}
    .supplement-material-tip-sub{font-size: 13px; font-weight: normal; color: #6A7282; margin-bottom: 16px;}
    .supplement-upload-toolbar{margin-bottom: 12px;}
    .supplement-file-input{display: none;}
    .supplement-pending-list,
    .supplement-view-list{margin: 0; padding: 0; list-style: none; max-height: 280px; overflow-y: auto;}
    .supplement-pending-list li,
    .supplement-view-list li{display: flex; align-items: center; padding: 10px 12px; border: 1px solid #E5E7EB; border-radius: 8px; margin-bottom: 8px; background: #F9FAFB;}
    .supplement-pending-name,
    .supplement-view-list a{flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #101828; font-size: 14px;}
    .supplement-view-list a{color: #E7000B; text-decoration: none;}
    .supplement-view-list a:hover{text-decoration: underline;}
    .supplement-pending-size{margin: 0 12px; color: #6A7282; font-size: 12px; white-space: nowrap;}
    .supplement-pending-del{padding: 0; color: #E7000B;}
    .supplement-pending-empty{color: #99A1AF; font-size: 14px; line-height: 24px; padding: 12px 0; text-align: center;}

    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>
